class ArticleFeaturedProductsDrawerTrigger extends HTMLButtonElement {
  constructor() {
    super();

  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    const template = this.querySelector('template');

    const drawerContent = template.content.cloneNode(true);

    const event = new CustomEvent(
      'article-featured-products-drawer:update',
      {
        detail: {
          drawerContent,
        },
        bubbles: true,
      }
    );

    this.dispatchEvent(event);
  }
}

customElements.define('article-featured-products-drawer-trigger', ArticleFeaturedProductsDrawerTrigger, { extends: 'button' });
